export const SPORTO_LOGO_URL = 'https://cdn.sporto.id/sporto-landscape.svg';
export const TERMS_OF_SERVICE_URL = 'https://sporto.id/tos';
export const PRIVACY_POLICY_URL = 'https://sporto.id/privacy-policy';
export const REMEMBER_IDENTIFIER_COOKIE = 'sporto_remember_identifier';
export const LINK_EXPIRY_MINUTES = 15;
